import type { GlobalShortcutsItem } from '../../types';
import { useDragAndDropOptions } from '../../utils/use-drag-and-drop-options';
import { useDragAndDropSave } from '../../utils/use-drag-and-drop-save';

type DragAndDropChangeProviderType = {
	children: React.ReactNode;
	shortcuts: GlobalShortcutsItem[];
};
export function DragAndDropChangeProvider({ shortcuts, children }: DragAndDropChangeProviderType) {
	const { enabled, handleDragAndDropChange } = useDragAndDropOptions();

	// initiates subscription to drag and drop changes
	useDragAndDropSave({
		enabled,
		shortcuts,
		handleDragAndDropChange,
	});

	return children;
}
